{
  "forms": {
    "function_label": "Función",
    "period_label": "Período",
    "name_label": "Nombre",
    "prompt_label": "Solicitud",
    "files_label": "Archivos",
    "view_label": "Vista",
    "device_function_label": "Dispositivo o Función",
    "operator_label": "Operador"
  },
  "errors": {
    "unexpected_error": "Lo sentimos, ocurrió un error inesperado, inténtelo de nuevo o póngase en contacto con Soporte"
  },
  "modals": {
    "share_dashboard": "Compartir Panel",
    "edit_dashboard": "Editar Panel",
    "confirmation": "¿Está seguro?",
    "delete_confirmation": "¿Está seguro de que desea eliminar esto? No puede deshacer esta acción"
  },
  "sections": {
    "settings": "Configuración",
    "basic_info": "Información",
    "alert_info": "Información de Alerta",
    "subscribers": "Suscriptores",
    "time_period": "Rango de Tiempo y Horario",
    "content_settings": "Contenido"
  },
  "tooltips": {
    "actions": "Acciones",
    "toggle_parameters": "Alternar Parámetros",
    "resize_widget": "Redimensionar Widget",
    "move_widget": "Mover Widget",
    "remove_condition": "Eliminar Condición",
    "see_standard_details": "Más información sobre este estándar",
    "see_aggregation_details": "Ver cómo funciona la agregación",
    "notification_methods": "Al elegir SMS o Email & SMS, cada usuario debe tener un número de teléfono válido en su perfil",
    "usb_battery": "Fuente de Batería USB"
  },
  "base": {
    "pagination": {
      "first_page": "Primera página",
      "last_page": "Última página",
      "prev_page": "Página anterior",
      "next_page": "Siguiente página"
    },
    "buttons": {
      "close": "Cerrar",
      "undo": "Deshacer",
      "cancel": "Cancelar",
      "apply": "Aplicar",
      "apply_changes": "Aplicar cambios",
      "add_new": "Agregar nuevo",
      "add": "Agregar",
      "edit": "Editar",
      "accept": "Aceptar",
      "reject": "Rechazar",
      "remove": "Eliminar",
      "reveal": "Revelar",
      "older": "Anterior",
      "newer": "Nuevo",
      "delete": "Eliminar",
      "remind": "Recordar",
      "admin": "Administrador",
      "view": "Ver",
      "clone": "Clonar",
      "duplicate": "Duplicate",
      "download": "Descargar",
      "download_pdf": "Descargar PDF",
      "pdf": "PDF",
      "submit": "Enviar",
      "sign_up": "registrarse",
      "create_new": "Crear nuevo",
      "lock": "Bloquear",
      "unlock": "Desbloquear",
      "save_changes": "Guardar cambios",
      "change": "Cambiar",
      "save": "Guardar",
      "transfer": "Transferir",
      "update": "Actualizar",
      "invite": "Invitar",
      "create": "Crear",
      "revoke": "Anular",
      "share": "Compartir",
      "configure": "Configurar",
      "configuration": "Configuración",
      "rollout": "Implementar",
      "reset_access": "Regresar a su cuenta",
      "run": "Ejecutar",
      "send": "Enviar",
      "manage": "Administrar",
      "continue_save": "OK",
      "reset": "Restablecer",
      "design_access_context": "Diseñar Contexto de Acceso",
      "design_access_back": "Volver a Su Cuenta",
      "pause_live_updates": "Pausar Actualizaciones en Vivo",
      "resume_live_updates": "Reanudar Actualizaciones en Vivo",
      "refresh_page": "Actualizar Página",
      "refresh": "Actualizar",
      "alert": "Alerta",
      "group_alert": "Alerta de Grupo",
      "activate": "Activar",
      "deactivate": "Desactivar",
      "monitor": "Monitorear"
    },
    "labels": {
      "all": "Todo",
      "value": "Valor",
      "settings": "Configuración",
      "select": "Selecionar",
      "with": "Con",
      "from": "De",
      "locked": "Bloqueado",
      "to": "Para",
      "actions": "Acciones",
      "loading": "cargando...",
      "show_all": "Mostrar todo",
      "show_more": "Mostrar más",
      "more": "más",
      "less": "menos",
      "no_records": "No se encontraron registros",
      "no_data": "No hay datos",
      "no_data_available": "No hay datos disponibles",
      "sent_invitations": "Enviar invitaciones",
      "list_view": "Consultar la lista",
      "grid_view": "Consultar la cuadrícula",
      "reload_data": "Cargar nuevamente los datos",
      "select_date": "Seleccionar datos",
      "select_all": "Seleccionar todo",
      "select_none": "Deseleccionar todo",
      "abs": "Abs",
      "abs_short": "Abs",
      "min": "Mínimo",
      "min_short": "Min",
      "avg": "Promedio",
      "avg_short": "Prom.",
      "max": "Máximo",
      "max_short": "Max",
      "warning": "Advertencia",
      "n_a": "N/A",
      "switched_on": "Activado",
      "switched_off": "Desactivado",
      "visible": "Visible",
      "hidden": "Oculto",
      "none": "Ninguno",
      "remove_all": "Remover todo",
      "auto": "Auto",
      "manual": "Manual",
      "or": "O",
      "yes": "Sí",
      "no": "No",
      "copy_to_clipboard": "Copiar al portapapeles",
      "copy_link": "Copiar enlace",
      "select_entity": "Seleccionar entidad",
      "copied": "¡Copiado!",
      "choose": "Seleccionar",
      "search_add_new": "Buscar o agregar nuevo...",
      "disabled": "Deshabilitado",
      "off": "Desactivado",
      "brand": "Marca:",
      "select_deselect_all": "Seleccionar / Deseleccionar todo"
    }
  },
  "hints": {
    "loadingWifiList": "La carga puede tardar hasta 1 minuto"
  },
  "us_states": {
    "select_state": "Seleccionar un estado"
  },
  "select_countries": "Seleccionar un país",
  "datepicker": {
    "select_date": "Seleccionar una fecha...",
    "custom_range": "Intervalo personalizado",
    "apply_label": "Aplicar",
    "cancel": "Cancelar",
    "unpin_time_selection": "Desanclar selección de tiempo",
    "keep_time_range": "Mantener rango de tiempo",
    "ranges": {
      "live": "En vivo",
      "today": "Hoy",
      "yesterday": "Ayer",
      "this_week": "Esta semana",
      "last_week": "La semana pasada",
      "this_month": "Este mes",
      "last_month": "El mes pasado"
    }
  },
  "time": {
    "never": "Nunca",
    "one_sec": "1 segundo",
    "number_secs": "%{n} segundos",
    "number_secs_short": "%{n} segs",
    "one_min": "1 minuto",
    "number_mins": "%{n} minutos",
    "number_mins_short": "%{n}minutos",
    "one_hour": "1 hora",
    "number_hours": "%{n} horas",
    "number_hours_short": "%{n}hora",
    "one_day": "1 día",
    "number_days": "%{n} días",
    "number_days_short": "%{n}d",
    "one_week": "1 semana",
    "number_weeks": "%{n} semanas",
    "number_weeks_short": "%{n}s",
    "one_month": "1 mes",
    "number_months": "%{n} meses",
    "one_year": "1 año",
    "number_years": "%{n} años",
    "last_duration": "Últimos %{duration}"
  },
  "dialogs": {
    "titles": {
      "auth_issue": "Problema con la autorización"
    },
    "token_expired": {
      "btn": "Ir a la página de inicio de sesión",
      "msg": "No es posible autorizar su cuenta. Intente iniciar sesión nuevamente."
    }
  },
  "notifications": {
    "empty": "No hay notificaciones"
  },
  "addresses": {
    "billing": {
      "section_title": "Dirección de facturación"
    },
    "shipping": {
      "section_title": "Dirección de entrega"
    }
  },
  "contact_infos": {
    "section_title": "Información de contacto"
  },
  "invitation_states": {
    "filed": "Pendiente",
    "accepted": "Aceptado",
    "rejected": "Rechazado"
  },
  "produced_by": "Producido por",
  "locale_name": "Español",
  "theme": {
    "light": "Tema Claro",
    "dark": "Tema Oscuro"
  },
  "groups": {
    "functions": "Funciones",
    "devices": "Dispositivos"
  },
  "operators": {
    "greater_or_equal": "Mayor o igual"
  },
  "admin_actions": {
    "reboot": "Reiniciar",
    "format": "Formatear",
    "sim_reset": "Reinicio de SIM"
  },
  "placeholders": {
    "choose_action": "Elegir acción..."
  },
  "units": {
    "auto": "Auto",
    "mg": "mg",
    "ug": "μg"
  },
  "percentages": {
    "off": "Desactivado",
    "25_percent": "25%",
    "50_percent": "50%",
    "75_percent": "75%",
    "100_percent": "100%"
  },
  "view_types": {
    "basic": "Básico",
    "extended": "Extendido"
  },
  "grid": {
    "columns": {
      "name": "Nombre",
      "message": "Mensaje",
      "last_triggered": "Última Activación",
      "status": "Estado",
      "condition": "Condición",
      "email": "Correo Electrónico",
      "user_role": "Rol de Usuario",
      "organization": "Organización",
      "created": "Creado",
      "organization_name": "Nombre de la Organización",
      "partner_name": "Nombre del Socio",
      "date_created": "Fecha de Creación",
      "address": "Dirección",
      "type": "Tipo",
      "from": "Desde",
      "to": "Hasta",
      "url": "URL",
      "enabled": "Habilitado",
      "last_updated": "Última Actualización",
      "result": "Resultado",
      "created_at": "Creado El",
      "timestamp": "Marca de Tiempo",
      "tag": "Etiqueta",
      "parameter": "Parámetro",
      "value": "Valor"
    }
  }
}